import { ID } from './common';
import { FullSource } from './source';

export interface Camera {
    id: ID;
    createdAt: number;
    updatedAt: number;
    name: string;
    streamUrl: string;
    username: string | null;
    password: string | null;
    userId: ID;
    sourceId: ID;
}

export type CameraReadOnly = Omit<Camera, 'password' | 'userId' | 'name'> & {
    source: FullSource;
};

export type CreateCameraPayload = Pick<
    Camera,
    'name' | 'streamUrl' | 'username' | 'password'
> & {
    faceRecognition: boolean;
    licensePlateRecognition: boolean;
    opticalCharacterRecognition: boolean;
    analysisFramesPerSecond: number;
};

export type CreateCamerasPayload = Array<CreateCameraPayload>;

export interface UpdateCameraPayload {
    name?: string;
    streamUrl?: string;
    username?: string | null;
    password?: string;
}

export enum ConnectionStatus {
    IDLE = 'idle',
    TESTING = 'testing',
    SUCCESS = 'success',
    ERROR = 'error',
}

export interface CameraConnectionStatus {
    status: ConnectionStatus;
    message?: string;
    lastChecked?: Date;
    snapshot?: string;
}

export enum CameraCreationStatus {
    PENDING = 'pending',
    CREATING = 'creating',
    TESTING = 'testing',
    COMPLETED = 'completed',
    ERROR = 'error',
}

export enum CameraValidationStatus {
    PENDING = 'pending',
    VALIDATING = 'validating',
    SUCCESS = 'success',
    ERROR = 'error',
}

export interface CameraCreationItem {
    id: string;
    name: string;
    streamUrl: string;
    username: string;
    password: string;
    faceRecognition: boolean;
    licensePlateRecognition: boolean;
    opticalCharacterRecognition: boolean;
    analysisFramesPerSecond: number;
    status: CameraCreationStatus;
    targetFolderId?: string | null;
    error?: string;
    createdCameraId?: string;
    createdSourceId?: string;
    validationStatus?: CameraValidationStatus;
    validationErrorType?: string;
    validationSnapshot?: string;
}
